import React from "react";

import { useTranslation } from "react-i18next";

function Button ( { className, color, text } ) {

    const { t } = useTranslation();
      
    return(
        <div className={className}>
            <a href="https://user.arvest-solid.net" target="_blank" rel="noopener noreferrer">
                <div className="button_main flex cursor-pointer rounded-[5px] hover:scale-[1.1] transition-all" style={{ backgroundColor: color }}>
                    <p className="text-white open-sans font-[400] text-[14px] xl:text-[18px]" style={{ color: text}}>{t('home.4')}</p>
                </div>
            </a>
        </div>
    );
}

export default Button;